export const G_variables = new Map();

export const G_variablesAsync = new Set();